import React from 'react';
import "./CustomNumberInput.css";

const CustomNumberInput = ({ label, value, onChange, min, max }) => {

  const handleIncrement = () => {
    const numericValue = parseInt(value, 10);
    if (numericValue < max) {
      onChange({ target: { value: numericValue + 1 } });
    }
  };

  const handleDecrement = () => {
    const numericValue = parseInt(value, 10);
    if (numericValue > min) {
      onChange({ target: { value: numericValue - 1 } });
    }
  };
  
  // Simulamos un evento 'e' para que el handler original funcione sin cambios
  const handleChange = (e) => {
    const numericValue = parseInt(e.target.value, 10);
    if (isNaN(numericValue)) {
        onChange({ target: { value: min } });
    } else if (numericValue >= min && numericValue <= max) {
        onChange(e);
    }
  }

  return (
    <div className="form-group">
      <label htmlFor={label}>{label}:</label>
      <div className="custom-number-input">
        <button type="button" onClick={handleDecrement} className="number-control-button">-</button>
        <input
          id={label}
          type="number"
          value={value}
          min={min}
          max={max}
          onChange={handleChange}
          required
        />
        <button type="button" onClick={handleIncrement} className="number-control-button">+</button>
      </div>
    </div>
  );
};

export default CustomNumberInput;